import React from 'react';
import AddtionalTenthDetails from './AdditionalTenth';
import AdditionalOthers from './AdditionalOthers';
import ERPUtils from '../../../../../helper/Utils';

const AdditonalEducationDetails = (props) => {
	const {
		countries,
		states,
		selectedRoundData,
		SelectedFormState,
		interviewDetails,
		onFileChange,
		openImageInTab,
		imageRemoveHandler,
		RequiredFields,
		setSelectedFormState
	} = props;

	return (
		<div>
			<h5 >
				Educational Details
			</h5>
			<div className="appDivider" />
			{
				ERPUtils.isUndefinedOrNull(selectedRoundData.educationalDetailDTO.highestQualificationLevelId) ===
					false ? (
					<div>
						{
							// SelectedFormState?.AdditonalEducationDetails?.qualificationList.sort((a, b) => parseInt(a?.qualificationLevelDegreeOrder) - parseInt(b?.qualificationLevelDegreeOrder)).map((els, index) => {
								// return (
									<div >
										<AddtionalTenthDetails
											// Tenth={els}
											// index={index}
											countries={countries}
											states={states}
											interviewDetails={interviewDetails}
											onFileChange={onFileChange}
											openImageInTab={openImageInTab}
											imageRemoveHandler={imageRemoveHandler}
											RequiredFields={RequiredFields}
											dataForDocsView={SelectedFormState?.AdditonalEducationDetails?.qualificationList}
											SelectedFormState={SelectedFormState}
											setSelectedFormState={setSelectedFormState}
											selectedRoundData={selectedRoundData}
										/>

									</div>
								// );
							// })
						}
						{/* {SelectedFormState.AdditonalEducationDetails.others.length > 0 ?
							SelectedFormState.AdditonalEducationDetails.others.map((el, index) => (
								<div key={index}>
									<AdditionalOthers
										others={el}
										interviewDetails={interviewDetails}
										onFileChange={onFileChange}
										openImageInTab={openImageInTab}
										imageRemoveHandler={imageRemoveHandler}
									/>
								</div>
							))
							: null} */}
					</div>
				) : null
			}
		</div >
	);
};

export default AdditonalEducationDetails;
